import graphql from "babel-plugin-relay/macro";

export default graphql`
  query OverrideReportPageQuery(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $sort: String
  ) {
    overrideReport(sort: $sort) {
      actions(first: $first, after: $after, last: $last, before: $before) {
        edges {
          node {
            document {
              pk
              name
              category {
                name
              }
              bloc {
                name
              }
            }
            overrideAction {
              pk
              actionDate
              comment
              user {
                pk
                firstName
                lastName
                title
              }
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
      error {
        statusCode
        message
      }
    }
  }
`;
